export default {
  email_confirm: {
    header: {
      title: "Confirmation de l'adresse e-mail terminée",
    },
    completed: {
      section_one: "Nous avons envoyé votre identifiant de connexion et votre mot de passe à l'adresse e-mail que vous avez indiquée.",
      section_two: 'Vérifiez votre e_mail et suivez les instructions qui y figurent pour vous connecter.',
      section_three: "Si vous ne l'avez pas reçu après 30 minutes, veuillez nous en informer à l'adresse",
      section_four: 'La personne responsable vous recontactera.',
    },
    expired: {
      section_one: "L'URL fournie est déjà expiré",
      section_two: 'Si vous souhaitez utiliser ce service, veuillez contacter ',
      section_three: 'La personne responsable vous contactera.',
    },
    btn: {
      service_top: 'Haut de page',
      login: 'Connexion',
      register: 'Enregistrer',
      rating_url: 'https://asuene.com/rating/en',
    },
  },
}
